import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';
import ReactModal from 'react-modal';

import styles from './about-modal.css';

import picoblockGearIcon from '../menu-bar/picoblock-logo-small.svg';

const AboutModal = ({onClose}) => (
    <ReactModal
        isOpen
        className={styles.modal}
        overlayClassName={styles.overlay}
        onRequestClose={onClose}
    >
        <div className={styles.header}>
            <span className={styles.headerTitle}>
                <FormattedMessage
                    defaultMessage="About PiCoBlock"
                    description="Title of the About modal"
                    id="gui.aboutModal.title"
                />
            </span>
            <button className={styles.closeButton} onClick={onClose}>✕</button>
        </div>
        <div className={styles.body}>
            <div className={styles.appInfo}>
                <div className={styles.logoWrap}>
                    <img
                        className={styles.logo}
                        src={picoblockGearIcon}
                        alt="PiCoBlock"
                        draggable={false}
                    />
                </div>
                <div className={styles.appDetails}>
                    <div className={styles.appName}>PiCoBlock</div>
                    <div className={styles.appVersion}>v1.0.0</div>
                    <a
                        className={styles.appUrl}
                        href="https://pico.ma/picoblock/"
                        rel="noopener noreferrer"
                        target="_blank"
                    >
                        {'pico.ma/picoblock/'}
                    </a>
                </div>
            </div>
            <hr className={styles.divider} />
            <div className={styles.footer}>
                <span className={styles.copyright}>
                    {'© 2025 PiCoAcademy. All rights reserved.'}
                </span>
                <div className={styles.links}>
                    <a
                        className={styles.link}
                        href="https://pico.ma/privacy"
                        rel="noopener noreferrer"
                        target="_blank"
                    >
                        <FormattedMessage
                            defaultMessage="Privacy Policy"
                            description="Privacy policy link in About modal"
                            id="gui.aboutModal.privacyPolicy"
                        />
                    </a>
                    <span className={styles.linkSep}>|</span>
                    <a
                        className={styles.link}
                        href="https://pico.ma/credits"
                        rel="noopener noreferrer"
                        target="_blank"
                    >
                        <FormattedMessage
                            defaultMessage="Credits"
                            description="Credits link in About modal"
                            id="gui.aboutModal.credits"
                        />
                    </a>
                </div>
            </div>
        </div>
    </ReactModal>
);

AboutModal.propTypes = {
    onClose: PropTypes.func.isRequired
};

export default AboutModal;
